import React from 'react';
import { cn } from '@/lib/utils';

/**
 * StatusBadge Component
 * 
 * Standardized status badge with pill styling and color variants.
 * Part of the Base44 Design System.
 * 
 * @param {string} variant - Color variant: success, warning, danger, info, neutral
 * @param {string} children - Badge content
 * @param {string} className - Additional classes
 */
export const StatusBadge = ({ 
  variant = 'neutral', 
  children, 
  className 
}) => {
  const variants = {
    success: 'bg-success text-success-foreground',
    warning: 'bg-amber-100 text-amber-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
    neutral: 'bg-slate-100 text-slate-700',
    active: 'bg-success text-success-foreground',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium',
        variants[variant] || variants.neutral,
        className
      )}
    >
      {children}
    </span>
  );
};
